import cssesc from 'cssesc';
import { COMPONENT_ID_PREFIX } from '../constants';

const getComponentId = (componentName, noPrefix = false, toLowerCase = false) => {
  let id = `${noPrefix ? '' : COMPONENT_ID_PREFIX}${componentName.replace(/\s+/g, '-')}`;
  if (toLowerCase) {
    id = id.toLowerCase();
  }
  return cssesc(id, { isIdentifier: true });
};

export default getComponentId;
